import React from "react";
// ---- Style ---- //
import "./index.scss";

// ---- Components ---- //

const OrderHeader = ({ setViewMode, viewMode }) => {
  const orderStatuses = [
    {
      name: "Новый:",
      amount: 0,
      color: "#FFDC00",
    },
    {
      name: "В обработке:",
      amount: 0,
      color: "#FFDC0050",
    },
    {
      name: "Отправлен:",
      amount: 0,
      color: "#007BFB",
    },
    {
      name: "Завершен:",
      amount: 0,
      color: "#00D359",
    },
    {
      name: "Отменен:",
      amount: 0,
      color: "#FF0C0C",
    },
  ];

  return (
    <div className="order__header orderHeader">
      <h2 className="orderHeader__title">Заказы</h2>
      <div className="orderHeader__main">
        {orderStatuses.map((status, index) => (
          <div className="orderHeader__status orderStatus" key={index}>
            <p className="orderStatus__text">
              {status.name} <span>{status.amount}</span>
            </p>
            <span
              className="orderStatus__before"
              style={{ background: status.color }}
            ></span>
          </div>
        ))}
      </div>
      <div className="orderList__viewToggle">
        <button
          onClick={() => setViewMode("list")}
          className={viewMode === "list" ? "active" : ""}
        >
          📝 Список
        </button>
        <button
          onClick={() => setViewMode("kanban")}
          className={viewMode === "kanban" ? "active" : ""}
        >
          🗂️ Канбан
        </button>
      </div>
      <div className="orderHeader__search"></div>
    </div>
  );
};

export default OrderHeader;
